var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapbox-container"},[_c('mapbox',{attrs:{"access-token":_vm.accessToken,"map-options":{
      style: 'mapbox://styles/appswithlove/ck6qy292404qg1inv9ubxrl03',
      center: [7.593740260641175, 47.561587809616569],
      zoom: 14,
      minZoom: 13,
      maxZoom: _vm.maxZoom, // second zoom level
    },"geolocate-control":{
      show: true,
      position: 'top-right',
      trackUserLocation: true,
    }},on:{"map-load":_vm.loaded,"map-init":_vm.mapInitialized,"geolocate-geolocate":_vm.geolocate}}),_vm._v(" "),(_vm.preview)?_c('teaser-preview',{attrs:{"offer":_vm.preview,"tops":_vm.tops,"maps":_vm.maps,"translate-detail":_vm.translateDetail}}):_vm._e(),_vm._v(" "),(_vm.fairground)?_c('fairground-preview',{attrs:{"fairground":_vm.fairground,"maps":_vm.maps,"translate-detail":_vm.translateDetail,"hide-offers":_vm.hideOffers}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }